import { GET_ALL_USER_DESIGNATIONS } from '../../types'

const INITIAL_STATE = {
  getAlluserDesignations: [],
}

const userDesignationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_USER_DESIGNATIONS:
      return {
        ...state,
        getAlluserDesignations: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default userDesignationReducer
